var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-block"},[_c('img',{staticClass:"blink",attrs:{"src":require("./../assets/spinner.png"),"height":"121"}})])
}]

export { render, staticRenderFns }